import { useCallback } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useUserSettings } from '@features/user/hooks/useUserSettings';
import { UserGameMenu } from '@features/user/ui/UserGameMenu/UserGameMenu';

export function UserGameMenuWidget() {
  const { user, login, logout } = useAuth();
  const settings = useUserSettings();

  const handleLogin = useCallback(() => login(), [login]);

  return <UserGameMenu user={user} onLogin={handleLogin} onLogout={logout} settings={settings} />;
}
